import React from "react";
import panelStyles from "../styles/Panel.module.css";

function joinClasses(...values) {
  return values.filter(Boolean).join(" ");
}

export function AdminPanel({
  id,
  title,
  isOpen = true,
  onToggle,
  actions,
  children,
  className,
  collapsible = Boolean(onToggle)
}) {
  const shouldRenderContent = collapsible ? isOpen : true;

  return (
    <section id={id} className={joinClasses(panelStyles.panel, className)}>
      {title || actions || collapsible ? (
        <div className={panelStyles.header}>
          <h2 className={panelStyles.title}>{title}</h2>
          <div className={panelStyles.headerActions}>
            {actions}
            {collapsible ? (
              <button type="button" className={panelStyles.toggleButton} onClick={onToggle}>
                {isOpen ? "Свернуть" : "Развернуть"}
              </button>
            ) : null}
          </div>
        </div>
      ) : null}
      {shouldRenderContent ? children : null}
    </section>
  );
}

export default AdminPanel;
